export default (theme) => ({
  root: {
    flex: 1,
    display: "flex",
  },
});
